'use client';

import { Box } from '@terra/ui-styled-system';
import { Text, MetricItem, EntityIcon } from '../../';
import { DetectionIcon } from './DetectionIcon';
import { DetectionMetricHoverCard } from './DetectionMetricHoverCard';
import { DETECTION_VIEW, type DetectionView } from './types';

export type DetectionMetricConfig = {
  key: 'findings' | 'signals';
  metricType: 'finding' | 'signal';
  hasMetric: boolean;
  activeMetric: number;
  totalMetric: number;
  inactiveMetric: number;
  activeLabel: string;
  totalLabel: string;
};

type DetectionMetricProps = {
  metric: DetectionMetricConfig;
  detectionView: DetectionView;
  endpointId: string;
  onViewFinding?: (findingId: string) => void;
  onViewSignal?: (signalId: string) => void;
  disableHover?: boolean;
};

export const DetectionMetric = ({
  metric,
  detectionView,
  endpointId,
  onViewFinding,
  onViewSignal,
  disableHover = false,
}: DetectionMetricProps) => {
  const metricContent = !metric.hasMetric ? (
    <Text fontSize="sm" color="fg.muted" minW="48px" textAlign="center">
      -
    </Text>
  ) : detectionView === DETECTION_VIEW.ACTIVE ? (
    <MetricItem
      hideTooltip
      icon={
        <Box w="6" display="inline-flex" justifyContent="flex-end">
          <EntityIcon type={metric.metricType} appearance="highlighted" />
        </Box>
      }
      label={metric.activeLabel}
      metrics={metric.activeMetric}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  ) : (
    <MetricItem
      hideTooltip
      icon={
        <DetectionIcon
          type={metric.metricType}
          activeCount={metric.activeMetric}
          inactiveCount={metric.inactiveMetric}
        />
      }
      label={metric.totalLabel}
      metrics={metric.totalMetric}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  if (!metric.hasMetric || disableHover) {
    return metricContent;
  }

  return (
    <DetectionMetricHoverCard
      type={metric.metricType}
      endpointId={endpointId}
      detectionView={detectionView}
      onViewFinding={onViewFinding}
      onViewSignal={onViewSignal}
    >
      {metricContent}
    </DetectionMetricHoverCard>
  );
};
